import React, { useEffect, useState } from "react";
import TmsTabsLayout from "../../../../components/tms-customs/tms-tabs-layout";
import tmsRouteMap from "../../../../constants/tms-route.map";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import TmsCmsSlots from "../../../common-manage-slots/tms-cms-slots";
import ShivaDeekshaInnerPagesAnd from "./sm-shiva-deeksha-inner-pages/shiva-deeksha-inner-pages-and";
import ShivaDeekshaInnerPagesAll from "./sm-shiva-deeksha-inner-pages/shiva-deeksha-inner-pages-all";

const SmShivaDeeksha = ({ router }) => {
  const [active, setActive] = useState("all");

  useEffect(() => {
    let location = router.location?.pathname;
    if (location === tmsRouteMap.serviceManagement_shiva_deeksha) {
      setActive("all");
      return;
    } else if (
      location.includes(tmsRouteMap.sm_shiva_deeksha_add_new_shiva_deeksha)
    ) {
      setActive("Add New Bhavani Deeksha");
    } else if (location.includes(tmsRouteMap.sm_shiva_deeksha_manage_counter)) {
      setActive("all");
      return;
    }
  }, [router.location?.pathname]);
  const location = router.location?.pathname;
  const components = [
    {
      name: "All",
      Element: location.includes(
        tmsRouteMap.sm_shiva_deeksha_manage_counter
      ) ? (
        <TmsCmsSlots type="shiva-deeksha-counters" />
      ) : (
        <ShivaDeekshaInnerPagesAll />
      ),
      key: "all",
      route: tmsRouteMap.serviceManagement_shiva_deeksha,
    },

    {
      name: "Add New Bhavani Deeksha",
      Element: <ShivaDeekshaInnerPagesAnd />,
      key: "Add New Bhavani Deeksha",
      route: tmsRouteMap.sm_shiva_deeksha_add_new_shiva_deeksha,
    },
  ];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TmsTabsLayout
        components={components}
        active={active}
        setActive={setActive}
      />
    </div>
  );
};
export default withRouter(SmShivaDeeksha);
